import script from "./base-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-input.vue?vue&type=script&setup=true&lang=ts"

import "./base-input.vue?vue&type=style&index=0&id=00005271&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00005271"]])

export default __exports__